App.factory('Operatory', ['restmod', restmod => restmod.model('/operatories')])